export const parseLocalStorageItem = (itemName) => {
  try {
    return JSON.parse(localStorage.getItem(itemName))
  } catch (error) {
    console.error(`Error parsing ${itemName} from localStorage:`, error)
    return null
  }
}
